import gql from 'graphql-tag'

export const adminBillingDebug = gql`
  query AdminBillingDebug($deviceId: String!) {
    adminBillingDebug(deviceId: $deviceId) {
      timestamp
      deviceId
      tables
      computed
      states
      summary
    }
  }
`
